import { Component, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-ayuda',
    templateUrl: './ayuda.component.html',
    styleUrls: ['./ayuda.component.css'],
    standalone: false
})
export class AyudaComponent {
  private router = inject(Router);
  private _location = inject(Location);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);

  // ===== estado (signals) =====
  error = signal<string>('');
  active1:string= "";
  active2:string= "";
  active3:string= "";
  active4:string= "";
  
  constructor(){
  }

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this.router.navigate(['/sign-in']);
      }
    });
  }
  
  activeone(){
    this.active1 = "active";
    this.active2 = "";
    this.active3 = "";
    this.active4 = "";
  }
  activetwo(){
    this.active2 = "active";
    this.active1 = "";
    this.active3 = "";
    this.active4 = "";
  }
  activethree(){
    this.active3 = "active";
    this.active2 = "";
    this.active1 = "";
    this.active4 = "";
  }
  activefour(){
    this.active4 = "active";
    this.active2 = "";
    this.active3 = "";
    this.active1 = "";
  }

  morer(){
    this.router.navigate(['/more']);
  }

  whatsapp(){
    window.open('https://api.whatsapp.com/send/?phone=5491144491372&text&type=phone_number&app_absent=0', "_blank");
  }

  email(){
    window.open('mailto: libresalud@cardio.ar', "_blank");
  }

  back(){
    this._location.back();
  }
}
